import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { PackageProvidersState } from './package-providers.reducer';

const packageProvidersState = (state: RootState): PackageProvidersState => state.packageProviders;

export const selectPackageProviders = createSelector(packageProvidersState, (state) => state.packageProviders);

export const selectPackageProvidersFetching = createSelector(packageProvidersState, (state) => state.fetching);
